import React, { FC, ReactElement, useEffect, useState } from "react";

import { useMsal } from "@azure/msal-react";

import { styled, Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import { Box, Button, Typography, Divider, Grid, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import apiCall from "../../utils/apiCall";
import PageHideToggle from "./PageHideToggle";
import {
  GET_IMAGE_DATA,
  GET_SHARED_DOCS,
  GET_USER_FORMATS,
  GET_USER_PROMPTS,
  GET_SHARED_IMAGE_DATA,
  GET_SHARED_IMAGES,
} from "../../endpoint";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import { useSelector } from "react-redux";
import { isdrawerOpening } from "../../redux/slices/drawerOpening";
import {
  addFiles,
  addPrompts,
  addSharedFiles,
  addUserFormats,
  getFiles,
  getPrompts,
  getSharedDocuments,
  getType,
  getUserFormats,
} from "../../redux/slices/typeSlice";
import { getSelectedIndexes } from "../../redux/slices/conversationSlice";
import {
  getSendingFullDocument,
  getuser,
  sendingfulldocument,
  getHidePageContent,
} from "../../redux/slices/userSlice";
import {
  getloadingforindexes,
  getloadingforprompts,
  getloadingforsharedDocs,
  getloadingforuserformats,
  loadingforSharedDocs,
  loadingforUserprompts,
  loadingforindexes,
  loadingforprompts,
} from "../../redux/slices/loadingSlice";

import {
  COLLECTION,
  DATABASE,
  EXCEL,
  IMAGE,
  NEO4J,
  PDF,
  VANILLA,
  YOUTUBE,
} from "../../data/constants";

import Loader from "../Loader";
import Prompt from "./Prompt";
import UploadFile from "../UploadFile";
import ImagePreviewModal from "./ImagePreviewModal";
import AccordianList from "./Accordian";
import AddUserFormat from "./AddUserFormat";
import ListOption from "./ListOption";
import AddButton from "./AddButton";
import UserFormat from "./UserFormat";
import { addError } from "../../redux/slices/errorSlice";
import SharedDoc from "./SharedDoc";
import Neo4jPreviewModal from "./Neo4jPreviewModal";
import Collection from "../Collection";
import ProModeSwitch from "./ProModeSwitch";
import PIIMode from "./PIIMode";
import SearchInput from "./SearchInput";

const drawerWidth = 250;
interface i_cred {
  password: string;
  url: string;
  username: string;
}

interface i_neo4j {
  cypher: string;
  show: boolean;
  setShow: any;
  creds: i_cred;
  db_name: string;
  instrcutions: string;
}

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  marginRight: "65px",
  borderRight: "1px solid rgba(0,0,0,.1)",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  marginRight: "65px",
  borderRight: "1px solid rgba(0,0,0,.1)",
});
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const SecondaryDrawerRight: FC<any> = (): ReactElement => {
  const dispatch = useAppDispatch();

  const [openUpload, setOpenUpload] = useState(false);
  const [imagedisplay, setImagedisplay] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [userFormatModal, setUserFormatModal] = useState(false);
  const [neo4jmodalshow, setNeo4jmodalshow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [neo4jData, setNeo4jData] = useState<i_neo4j>();
  const selectedIndexes = useAppSelector(getSelectedIndexes);
  const files = useAppSelector(getFiles);
  const indexloading = useAppSelector(getloadingforindexes);
  const chatType = useAppSelector(getType);
  const prompts = useAppSelector(getPrompts);
  const promptloading = useAppSelector(getloadingforprompts);
  const userFormats = useAppSelector(getUserFormats);
  const userFormatsLoading = useAppSelector(getloadingforuserformats);
  const user = useAppSelector(getuser);
  const sharedDocs = useAppSelector(getSharedDocuments);
  const sharedDocsLoading = useAppSelector(getloadingforsharedDocs);
  const toggle = useAppSelector(getSendingFullDocument);
  const hidePageContent = useAppSelector(getHidePageContent);
  const { accounts } = useMsal();
  const account = accounts[0];
  const [showSearch, setShowSearch] = useState("");

  useEffect(() => {
    const fetchData = () => {
      if (chatType?.geturl !== "") {
        dispatch(loadingforindexes(true));
        apiCall("POST", chatType.geturl, {
          user_email: account.username,
        })
          .then((res) => {
            dispatch(addFiles(res.result));
          })
          .catch((err) => {
            dispatch(addError("Failed to upload the files.Please try again."));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
          });
      }
    };
    const fetchPrompts = () => {
      dispatch(loadingforprompts(true));
      if (user?.user_id) {
        apiCall("POST", GET_USER_PROMPTS, {
          user_email: account?.username,
          chat_type: chatType?.prompt_storage,
        })
          .then((res) => {
            dispatch(addPrompts(res.result));
          })
          .catch((err) => {
            dispatch(
              addError("Failed to load the saved queries.Please try again.")
            );
          })
          .finally(() => {
            dispatch(loadingforprompts(false));
          });
      }
    };
    const fetchUserFormats = () => {
      dispatch(loadingforUserprompts(true));
      if (user.user_id) {
        apiCall("POST", GET_USER_FORMATS, {
          user_email: account.username,
          chat_type: chatType.prompt_storage,
        })
          .then((res) => {
            dispatch(addUserFormats(res.result));
          })
          .catch((err) => {
            dispatch(addError("Failed to load the prompts.Please try again."));
          })
          .finally(() => {
            dispatch(loadingforUserprompts(false));
          });
      }
    };
    const fetchSharedDocs = () => {
      dispatch(loadingforSharedDocs(true));
      apiCall("POST", GET_SHARED_DOCS)
        .then((res: any) => {
          dispatch(addSharedFiles(res.result));
        })
        .catch((err) => {
          dispatch(
            addError("Failed to load the shared documents.Please try again.")
          );
        })
        .finally(() => {
          dispatch(loadingforSharedDocs(false));
        });
    };

    const fetchSharedImages = () => {
      dispatch(loadingforSharedDocs(true));
      apiCall("POST", GET_SHARED_IMAGES)
        .then((res: any) => {
          dispatch(addSharedFiles(res.result));
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while getting shared files"));
          console.error(err);
        })
        .finally(() => {
          dispatch(loadingforSharedDocs(false));
        });
    };

    fetchData();
    fetchPrompts();
    fetchUserFormats();
    if (chatType.type === PDF) fetchSharedDocs();
    if (chatType.type === IMAGE) fetchSharedImages();
    setShowSearch("");
  }, [chatType?.type]);

  const getImage = (type: string) => {
    if (chatType.type === IMAGE) {
      setImagedisplay("");
      setShowImageModal(true);
      apiCall("POST", GET_IMAGE_DATA, {
        user_email: account.username,
        image_name: type,
      })
        .then((res: any) => {
          setImagedisplay(res.result);
        })
        .catch((err) => {
          setShowImageModal(false);
          dispatch(addError("Failed to load all images.Please try again."));
        });
    }
  };

  const getsharedImage = (type: string) => {
    if (chatType.type === IMAGE) {
      setImagedisplay("");
      setShowImageModal(true);
      apiCall("POST", GET_SHARED_IMAGE_DATA, {
        user_email: account.username,
        image_name: type,
      })
        .then((res: any) => {
          setImagedisplay(res.result);
        })
        .catch((err) => {
          setShowImageModal(false);
          console.error(err);
        });
    }
  };

  const getNeo4jData = (data: any) => {
    setNeo4jData(data);
    setNeo4jmodalshow(true);
  };
  useEffect(() => {
    setSearchText("");
  }, [showSearch]);
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: "70px",
          right: hidePageContent ? "50px" : "300px",
          zIndex: 120,
          transition: "right 0.3s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          visibility: "visible",
        }}
      >
        <PageHideToggle />
      </Box>
      
      {!hidePageContent && (
      <Drawer variant="permanent" open={true} anchor="right">
        <Divider
          sx={{
            mt: 8,
          }}
        />
        <>

        {chatType?.type === COLLECTION ? (
          <Collection
            showSearch={showSearch}
            setShowSearch={setShowSearch}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        ) : (
          <>
            {chatType?.type === PDF && (
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                sx={{
                  mb: -1,
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                }}
              >
                <ProModeSwitch />
              </Grid>
            )}
            {/* {(chatType?.type === PDF || chatType?.type === VANILLA) && (
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                sx={{
                  mb: -1,
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                }}
              >
                <PIIMode />
              </Grid>
            )} */}
            {indexloading && (
              <Grid
                sx={{
                  height: "10px",
                  mt: 1,
                }}
              >
                <Loader />
              </Grid>
            )}
            {chatType?.geturl !== "" && (
              <>
                {files?.length === 0 ? (
                  <>
                    <Typography
                      align="center"
                      sx={{
                        my: 8,
                      }}
                      color="primary"
                    >
                      {chatType?.type === YOUTUBE
                        ? "No Video URLs "
                        : "No files "}
                      uploaded yet
                    </Typography>
                    <Button
                      id="uploadfile"
                      onClick={(e) => {
                        setOpenUpload(true);
                        e.stopPropagation();
                      }}
                      variant="contained"
                      color="primary"
                      sx={{
                        width: "90%",
                        margin: "auto",
                      }}
                    >
                      Upload file
                    </Button>
                  </>
                ) : (
                  <AccordianList
                    title={
                      chatType?.type === YOUTUBE
                        ? "Video URLs"
                        : "Uploaded Files"
                    }
                    addbutton={
                      <AddButton
                        onClick={(e) => {
                          setOpenUpload(true);
                          e.stopPropagation();
                        }}
                      />
                    }
                    height={20}
                    showingLoaders={true}
                    showSearch={files?.length > 2 && showSearch !== "files"}
                    onSearchClick={() => setShowSearch("files")}
                  >
                    <>
                      {showSearch === "files" && (
                        <SearchInput
                          onCancelClick={() => setShowSearch("")}
                          searchText={searchText}
                          setSearchText={setSearchText}
                        />
                      )}
                      {files
                        ?.filter((obj) =>
                          obj
                            ?.split("---")?.[0] //removed suffix
                            ?.toLowerCase()
                            ?.includes(
                              showSearch === "files"
                                ? searchText.toLowerCase()
                                : ""
                            )
                        )
                        .map((type, index) => (
                          <React.Fragment key={index}>
                            {chatType?.type === NEO4J ? (
                              <ListOption
                                type={type?.db_name}
                                checkboxcondition={
                                  selectedIndexes[0] === type?.db_name
                                }
                                fileType={"neo4j"}
                                onClick={() => getNeo4jData(type)}
                                key={index}
                                data={type}
                                title="Click to see more details"
                              />
                            ) : chatType?.type === DATABASE ||
                              chatType?.type === EXCEL ? (
                              <ListOption
                                type={type}
                                checkboxcondition={selectedIndexes[0] === type}
                                fileType={
                                  chatType?.type === DATABASE ? "sql" : "excel"
                                }
                                onClick={() => null}
                                key={index}
                              />
                            ) : (
                              <ListOption
                                type={type}
                                checkboxcondition={selectedIndexes.includes(
                                  type
                                )}
                                fileType={
                                  type?.split("---")[
                                    chatType?.type === PDF ||
                                    chatType?.type === YOUTUBE
                                      ? 2
                                      : 1
                                  ]
                                }
                                onClick={() => getImage(type)}
                                key={index}
                                title={
                                  chatType?.type === IMAGE
                                    ? "Click to see image"
                                    : ""
                                }
                              />
                            )}
                          </React.Fragment>
                        ))}
                    </>
                  </AccordianList>
                )}
              </>
            )}
            {(chatType.type === PDF || chatType.type === IMAGE) && (
              <>
                {sharedDocsLoading && <Loader />}
                <div id="shareddoc">
                  <AccordianList
                    title={
                      chatType.type === PDF
                        ? "Shared Documents"
                        : "Shared Images"
                    }
                    addbutton={<></>}
                    height={20}
                    showingLoaders={true}
                    showSearch={
                      sharedDocs?.length > 2 && showSearch !== "sharedDocs"
                    }
                    onSearchClick={() => setShowSearch("sharedDocs")}
                  >
                    <>
                      {showSearch === "sharedDocs" && (
                        <SearchInput
                          onCancelClick={() => setShowSearch("")}
                          searchText={searchText}
                          setSearchText={setSearchText}
                        />
                      )}
                      {sharedDocs
                        ?.filter((obj) =>
                          obj
                            ?.split("---")?.[0] //removed suffix
                            ?.toLowerCase()
                            ?.includes(
                              showSearch === "sharedDocs"
                                ? searchText.toLowerCase()
                                : ""
                            )
                        )
                        ?.map((file, index) => (
                          <SharedDoc
                            type={file}
                            checkboxcondition={selectedIndexes.includes(file)}
                            fileType={
                              file.split("---")[chatType.type === PDF ? 2 : 1]
                            }
                            key={index}
                            onClick={() => getsharedImage(file)}
                            title={
                              chatType.type === IMAGE
                                ? "Click to see image"
                                : ""
                            }
                          />
                        ))}
                    </>
                  </AccordianList>
                </div>
              </>
            )}
          </>
        )}
      </>
        {userFormatsLoading && <Loader />}
        <div id="prompt">
          <AccordianList
            title="Prompt Library"
            addbutton={
              <AddButton
                onClick={(e) => {
                  setUserFormatModal(true);
                  e.stopPropagation();
                }}
              />
            }
            height={20}
            showingLoaders={true}
            showSearch={userFormats?.length > 2 && showSearch !== "prompts"}
            onSearchClick={() => setShowSearch("prompts")}
          >
            <>
              {showSearch === "prompts" && (
                <SearchInput
                  onCancelClick={() => setShowSearch("")}
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              )}
              {userFormats
                ?.filter((obj) =>
                  obj
                    ?.split("---")?.[0] //removed suffix
                    ?.toLowerCase()
                    ?.includes(
                      showSearch === "prompts" ? searchText.toLowerCase() : ""
                    )
                )
                ?.map((prompt, index) => (
                  <UserFormat value={prompt} key={prompt} />
                ))}
            </>
          </AccordianList>
        </div>
        {promptloading && <Loader />}
        <div id="saved">
          <AccordianList
            title="Saved Queries"
            addbutton={<></>}
            height={20}
            onSearchClick={() => setShowSearch("queries")}
            showSearch={prompts?.length > 2 && showSearch !== "queries"}
          >
            <>
              {showSearch === "queries" && (
                <SearchInput
                  onCancelClick={() => setShowSearch("")}
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              )}
              {prompts
                ?.filter((obj) =>
                  obj
                    ?.split("---")?.[0] //removed suffix
                    ?.toLowerCase()
                    ?.includes(
                      showSearch === "queries" ? searchText.toLowerCase() : ""
                    )
                )
                ?.map((li, i) => (
                  <Prompt value={li} key={li} />
                ))}
            </>
          </AccordianList>
        </div>
        </Drawer>
      )}
      <UploadFile
        open={openUpload}
        setOpen={(value: boolean) => setOpenUpload(value)}
      />
      <ImagePreviewModal
        image={imagedisplay}
        show={showImageModal}
        setShow={setShowImageModal}
      />
      <Neo4jPreviewModal
        data={neo4jData}
        show={neo4jmodalshow}
        setShow={setNeo4jmodalshow}
      />
      <AddUserFormat show={userFormatModal} setShow={setUserFormatModal} />
    </>
  );
};

export default SecondaryDrawerRight;
